import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, ArrowRight } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import { ROUTES, BASE_URL } from '../seo/routeMetadata';
import { LEARN_ARTICLES } from '../seo/seoContent';

const LearnHubPage = () => {
  const meta = ROUTES['/learn'];

  return (
    <div className="min-h-screen bg-[#050810]">
      <SEO
        title={meta.title}
        description={meta.description}
        keywords={meta.keywords}
        url={`${BASE_URL}${meta.path}`}
        jsonLd={meta.jsonLd}
      />
      <Header />
      <main className="max-w-5xl mx-auto px-4 sm:px-6 py-10">
        <header className="mb-10 pb-8 border-b border-[#1e2a45]">
          <nav aria-label="Breadcrumb" className="mb-6 text-xs text-gray-500">
            <Link to="/" className="hover:text-white">Home</Link>
            <span className="mx-2 text-gray-600">›</span>
            <span className="text-gray-400">Learn</span>
          </nav>

          <div className="flex items-center gap-3 mb-4">
            <BookOpen className="h-7 w-7 text-[#3B82F6]" />
            <h1 className="text-4xl sm:text-5xl font-bold text-white leading-tight" data-testid="page-h1">{meta.h1}</h1>
          </div>
          <p className="text-lg text-gray-200 leading-relaxed max-w-3xl">{meta.aeoAnswer}</p>
        </header>

        <div className="grid gap-4 md:grid-cols-2">
          {Object.entries(LEARN_ARTICLES).map(([slug, art]) => (
            <Link
              key={slug}
              to={`/learn/${slug}`}
              data-testid={`learn-card-${slug}`}
              className="group block rounded-2xl border border-[#1e2a45] bg-[#131b2e] hover:border-[#3B82F6]/50 p-6 transition-colors"
            >
              <h2 className="text-xl font-semibold text-white mb-2 group-hover:text-[#3B82F6]">{art.title}</h2>
              <p className="text-sm text-gray-400 leading-relaxed">{art.description}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm text-[#3B82F6]">
                Read article <ArrowRight className="h-4 w-4" />
              </span>
            </Link>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default LearnHubPage;
